export const GET_TASKS_QUERY = `
  query GetTasks($where: tasks_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [tasks_order_by!] = [{ created_at: desc }]) {
    tasks_aggregate(where: $where) {
      aggregate { count }
    }
    tasks(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      task_title
      task_description
      task_start_date
      task_due_date
      task_status
      firm_id
      company_id
      created_by
      created_at
      updated_at
      firm {
        id
        firm_name
        firm_short_name
      }
      company {
        id
        name
      }
      user {
        id
        first_name
        last_name
      }
    }
  }
`;

export const GET_TASK_BY_ID_QUERY = `
  query GetTaskById($id: uuid!) {
    tasks_by_pk(id: $id) {
      id
      task_title
      task_description
      task_start_date
      task_due_date
      task_status
      firm_id
      company_id
      created_by
      created_at
      updated_at
      firm {
        id
        firm_name
        firm_short_name
      }
      company {
        id
        name
      }
      user {
        id
        first_name
        last_name
      }
    }
  }
`;
